import store from './../store';
import router from './../router';
import {auth} from './../firebase';
import isAfter from 'date-fns/isAfter';
import parseISO from 'date-fns/parseISO';
import { PLAN_TO_SECTIONS_MAP } from './subscriptionHelpers';

export let currentRoleLevelName ='';

export const PARTY_LAWYER_INVITER_ROLES = ['client-level-2', 'client-level-3'];
export const PARTY_INVITABLE_LAWYER_ROLE = 'lawyer-level-2';
export const SHARED_PRIMARY_LAWYER_ROLE = 'lawyer-level-1';

export function isPartyLawyerInviterRole() {
	return PARTY_LAWYER_INVITER_ROLES.includes(currentRoleLevelName);
}

/** Invited Primary Lawyer on an agreement (may lack owner/primaryLawyer flags). */
export function isSharedPrimaryLawyerRole() {
	return currentRoleLevelName === SHARED_PRIMARY_LAWYER_ROLE;
}

/** Share button / panel visibility */
export function canViewShareAgreement() {
	allPermissionsAvailable();
	return (
		isSharedPrimaryLawyerRole() ||
		isPartyLawyerInviterRole() ||
		hasViewPermission('share-agreement')
	);
}

/** Add collaborators: owners/shared primary lawyers, party L2/L3, or role config */
export function canAddShareAgreement() {
	allPermissionsAvailable();
	return (
		isSharedPrimaryLawyerRole() ||
		isPartyLawyerInviterRole() ||
		hasAddPermission('share-agreement')
	);
}

/**
 * Delete collaborators: shared primary lawyers can remove any;
 * party level 2/3 limited to lawyer-level-2 and self.
 */
export function canDeleteShareAgreement(targetUser) {
	allPermissionsAvailable();
	if (!targetUser || !targetUser.role) {
		return false;
	}
	if (isSharedPrimaryLawyerRole()) {
		return true;
	}
	if (isPartyLawyerInviterRole()) {
		const loggedInEmail = auth.currentUser?.email;
		if (
			loggedInEmail &&
			targetUser.email &&
			loggedInEmail.toLowerCase() === targetUser.email.toLowerCase()
		) {
			return true;
		}
		return targetUser.role === PARTY_INVITABLE_LAWYER_ROLE;
	}
	return hasDeletePermission('share-agreement');
}

/** Role editing: shared primary lawyers yes; party L2/L3 no */
export function canEditShareAgreement() {
	allPermissionsAvailable();
	if (isPartyLawyerInviterRole()) {
		return false;
	}
	return isSharedPrimaryLawyerRole() || hasAddPermission('share-agreement');
}

/** Code-enforced invite UI for party level 2/3 (lawyer-level-2 only) */
export function hasPartyLawyerInviteRestrictions() {
	allPermissionsAvailable();
	return isPartyLawyerInviterRole();
}
export function allPermissionsAvailable() {
	let currentRoleLevel;
	localStorage.removeItem('clientUserAgreement')
	if(router.currentRoute.name == 'agreement' && store.state.permissions && Object.keys(store.state.permissions)?.length){
		const loggedInEmailID = auth.currentUser?.email
		const userFromAgreementPermissions = Object.values(store.state.permissions).find(({ email }) => email === loggedInEmailID);
		if(userFromAgreementPermissions?.role && store.state?.roleLevels?.length){
			if(userFromAgreementPermissions?.isClientUser && router.currentRoute.params?.id){
				localStorage.setItem('clientUserAgreement',router.currentRoute.params.id)
			}
			if(store.state?.roleLevels)
			currentRoleLevel = store.state.roleLevels.find(({ roleName }) => roleName === userFromAgreementPermissions.role) || {};
		} else {
			currentRoleLevel = store.getters.getCurrentRoleLevel ? store.getters.getCurrentRoleLevel : {};
		}
	} else {
		currentRoleLevel = store.getters.getCurrentRoleLevel ? store.getters.getCurrentRoleLevel : {};//localStorage.getItem('currentRoleLevel') ? JSON.parse(localStorage.getItem('currentRoleLevel')) : {};
	}
	// console.log('router.currentRoute --------- ==>',router.currentRoute);
	// console.log('currentRoleLevel --------- ==>',currentRoleLevel.roleName);//localStorage.getItem('currentRoleLevel') ? JSON.parse(localStorage.getItem('currentRoleLevel')) : {};
	currentRoleLevelName = currentRoleLevel.roleName;
	store.commit('setCurrentRoleLevelName', currentRoleLevel.roleName);
	return currentRoleLevel.permissions;
}

export function permissionAvailable(module) {
	let allPerm = allPermissionsAvailable();
	if(module == 'share-agreement' || module == 'section-basics' ||
	module == 'section-parenting' || module == 'section-child-support' ||
	module == 'section-spousal-support'|| module == 'section-support-additionals'  || module == 'section-property' ||
	module == 'section-final-clauses' || module == 'section-other-partner-details' || module == 'description'){
		let builderPresent = allPerm?.length && allPerm.find((perm)=>perm.value == 'builder');
		return builderPresent?.options?.find((perm)=>perm.value == module)
	} else
	return allPerm && allPerm.length && allPerm.find((perm)=>perm.value == module)
}

export function hasViewPermission(module){
	return permissionAvailable(module) ? permissionAvailable(module).hasViewPermission : false;
}

export function hasAddPermission(module){
	return permissionAvailable(module) ? permissionAvailable(module).hasAddPermission : false;
}

export function hasEditPermission(module){
	return permissionAvailable(module) ? permissionAvailable(module).hasEditPermission : false;
}

export function hasDeletePermission(module){
	return permissionAvailable(module) ? permissionAvailable(module).hasDeletePermission : false;
}

export function isClientUserAgreement(){
	return store.state.agreements.find((agr)=> agr.id== router.currentRoute.params.id && agr.isClientUser == true) ? true : false
}

export function trialActiveForClients(){
	const { trialEnd } = store.state.userProfile;
	const payments = store.state.payments;
	const hasPayments = payments && payments.length > 0;

	return hasPayments
		? false
		: trialEnd && isAfter(parseISO(trialEnd), new Date()) && currentRoleLevelName === 'client-level-1';
}

export function isSectionRestrictedByPlan(sectionName) {
	const { currentRoleLevel } = store.state;

	// Only apply to party users
	if (!currentRoleLevel || currentRoleLevel.roleAssociated !== 'party') {
		return false;  // Don't hide for non-party users
	}

	// Get active subscription plan
	const activePlan = store.getters.activePaymentForSeparatingParty;

	// If no active plan, don't hide (let other checks handle it)
	if (!activePlan) {
		return false;
	}


	const allowedSections = PLAN_TO_SECTIONS_MAP[activePlan];
	if (!allowedSections) {
		return false;
	}

	// Return true if section is NOT in allowed list (should be hidden)
	return !allowedSections.includes(sectionName);
}